import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

interface IProps {
  message: string;
}

function SuccessStatusLine({ message }: IProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mt: '6px', ml: '-2px' }}>
      <CheckIcon color='success' />
      <Typography variant='h4' sx={{ ml: '9px', fontWeight: 'normal' }}>
        {message}
      </Typography>
    </Box>
  );
}

export default SuccessStatusLine;
